export default "<img *ngIf=\"imageUrl\" [src]=\"imageUrl\">\n";